import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance2xbytizsyx2ps as Companion_getInstance,
  ViewWrapper1d2k0qoolhu36 as ViewWrapper,
} from '../../ViewWrapper.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance_0,
  _Dimension___get_value__impl__urhqzr1mx919605mj8b as _Dimension___get_value__impl__urhqzr,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../models/data.mjs';
import { FloatingInfoHolder1eisb99cxddo9 as FloatingInfoHolder } from './FloatingInfoHolder.js.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { RViewWrapper2fs4vvl2qig0l as RViewWrapper } from '../RView.mjs';
import {
  nativeAnimateHide1gje1vrdzq766 as nativeAnimateHide,
  nativeAnimateShow1mpbjsmv28ail as nativeAnimateShow,
} from './modifiers.commonHtml.js.mjs';
import { get_areAnimationsEnabled2k2xqxuhspcz8 as get_areAnimationsEnabled } from '../RView.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../models/data.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function align(_this__u8e3s4, horizontal, vertical) {
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    _this__u8e3s4.lb6_1 = horizontal;
    _this__u8e3s4.mb6_1 = vertical;
    _this__u8e3s4.vb5_1.jb4_1.v('h' + horizontal.toString());
    _this__u8e3s4.vb5_1.fb4_1 = horizontal;
    _this__u8e3s4.vb5_1.jb4_1.v('v' + vertical.toString());
    _this__u8e3s4.vb5_1.eb4_1 = vertical;
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
function weight(_this__u8e3s4, amount) {
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    _this__u8e3s4.kb6_1 = amount;
    var tmp0 = _this__u8e3s4.vb5_1.db4_1;
    // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
    var value = '' + amount;
    tmp0.hb7_1.flexGrow = value;
    var tmp0_0 = _this__u8e3s4.vb5_1.db4_1;
    // Inline function 'com.lightningkite.kiteui.views.flexShrink' call
    var value_0 = '' + amount;
    tmp0_0.hb7_1.flexShrink = value_0;
    // Inline function 'com.lightningkite.kiteui.views.flexBasis' call
    _this__u8e3s4.vb5_1.db4_1.hb7_1.flexBasis = '0';
    var tmp0_safe_receiver_0 = _this__u8e3s4.tb6_1;
    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.vb5_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.jb4_1;
    if (tmp2_safe_receiver == null)
      null;
    else
      tmp2_safe_receiver.v('childHasWeight');
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
function shownWhen(_this__u8e3s4, default_0, condition) {
  default_0 = default_0 === VOID ? false : default_0;
  var v = {_v: null};
  _this__u8e3s4.fbb(new (shownWhen$1())(v, default_0, _this__u8e3s4, condition));
  return new (shownWhen$2())(v);
}
function hintPopover(_this__u8e3s4, preferredDirection, setup) {
  preferredDirection = preferredDirection === VOID ? Companion_getInstance_0().zcq_1 : preferredDirection;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    var floating = new (FloatingInfoHolder())(_this__u8e3s4);
    floating.oc2_1 = setup;
    floating.mc2_1 = preferredDirection;
    var tmp0 = _this__u8e3s4.vb5_1;
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
    var name = 'contextmenu';
    var tmp0_safe_receiver_0 = tmp0.xb3_1;
    var tmp;
    if (tmp0_safe_receiver_0 == null) {
      tmp = null;
    } else {
      tmp0_safe_receiver_0.addEventListener(name, (it) => {
        floating.ec4();
        return Unit_instance;
      });
      tmp = Unit_instance;
    }
    if (tmp == null) {
      // Inline function 'kotlin.run' call
      var tmp_0 = tmp0.gb4_1['on' + name];
      var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
      var tmp_1 = 'on' + name;
      tmp0.gb4_1[tmp_1] = (it) => {
        var tmp0_safe_receiver = old;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(it);
        floating.ec4();
        return Unit_instance;
      };
    }
    var tmp0_0 = _this__u8e3s4.vb5_1;
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
    var name_0 = 'mouseenter';
    var tmp0_safe_receiver_1 = tmp0_0.xb3_1;
    var tmp_2;
    if (tmp0_safe_receiver_1 == null) {
      tmp_2 = null;
    } else {
      tmp0_safe_receiver_1.addEventListener(name_0, (it) => {
        floating.ec4();
        return Unit_instance;
      });
      tmp_2 = Unit_instance;
    }
    if (tmp_2 == null) {
      // Inline function 'kotlin.run' call
      var tmp_3 = tmp0_0.gb4_1['on' + name_0];
      var old_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'function' : false) ? tmp_3 : null;
      var tmp_4 = 'on' + name_0;
      tmp0_0.gb4_1[tmp_4] = (it) => {
        var tmp0_safe_receiver = old_0;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(it);
        floating.ec4();
        return Unit_instance;
      };
    }
    var tmp0_1 = _this__u8e3s4.vb5_1;
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
    var name_1 = 'mouseleave';
    var tmp0_safe_receiver_2 = tmp0_1.xb3_1;
    var tmp_5;
    if (tmp0_safe_receiver_2 == null) {
      tmp_5 = null;
    } else {
      tmp0_safe_receiver_2.addEventListener(name_1, (it) => {
        floating.mcr();
        return Unit_instance;
      });
      tmp_5 = Unit_instance;
    }
    if (tmp_5 == null) {
      // Inline function 'kotlin.run' call
      var tmp_6 = tmp0_1.gb4_1['on' + name_1];
      var old_1 = (!(tmp_6 == null) ? typeof tmp_6 === 'function' : false) ? tmp_6 : null;
      var tmp_7 = 'on' + name_1;
      tmp0_1.gb4_1[tmp_7] = (it) => {
        var tmp0_safe_receiver = old_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(it);
        floating.mcr();
        return Unit_instance;
      };
    }
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
function changingSizeConstraints(_this__u8e3s4, constraints) {
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    var $this$beforeNextElementSetup = _this__u8e3s4;
    reactiveScope($this$beforeNextElementSetup, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var constraints_0 = constraints($this$reactiveScope);
      var tmp;
      var tmp_0 = constraints_0.pcr_1;
      if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.minHeight' call
        $this$beforeNextElementSetup.vb5_1.db4_1.hb7_1.minHeight = null;
        tmp = Unit_instance;
      } else {
        var tmp0 = $this$beforeNextElementSetup.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.minHeight' call
        var value = _Dimension___get_value__impl__urhqzr(constraints_0.pcr_1).toString();
        tmp0.hb7_1.minHeight = value;
        tmp = Unit_instance;
      }
      var tmp_1;
      var tmp_2 = constraints_0.qcr_1;
      if ((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.maxHeight' call
        $this$beforeNextElementSetup.vb5_1.db4_1.hb7_1.maxHeight = null;
        tmp_1 = Unit_instance;
      } else {
        var tmp0_0 = $this$beforeNextElementSetup.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.maxHeight' call
        var value_0 = _Dimension___get_value__impl__urhqzr(constraints_0.qcr_1).toString();
        tmp0_0.hb7_1.maxHeight = value_0;
        tmp_1 = Unit_instance;
      }
      var tmp_3;
      var tmp_4 = constraints_0.ncr_1;
      if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.minWidth' call
        $this$beforeNextElementSetup.vb5_1.db4_1.hb7_1.minWidth = null;
        tmp_3 = Unit_instance;
      } else {
        var tmp0_1 = $this$beforeNextElementSetup.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.minWidth' call
        var value_1 = _Dimension___get_value__impl__urhqzr(constraints_0.ncr_1).toString();
        tmp0_1.hb7_1.minWidth = value_1;
        tmp_3 = Unit_instance;
      }
      var tmp_5;
      var tmp_6 = constraints_0.ocr_1;
      if ((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.maxWidth' call
        $this$beforeNextElementSetup.vb5_1.db4_1.hb7_1.maxWidth = null;
        tmp_5 = Unit_instance;
      } else {
        var tmp0_2 = $this$beforeNextElementSetup.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.maxWidth' call
        var value_2 = _Dimension___get_value__impl__urhqzr(constraints_0.ocr_1).toString();
        tmp0_2.hb7_1.maxWidth = value_2;
        tmp_5 = Unit_instance;
      }
      var tmp_7;
      if (constraints_0.rcr_1 == null) {
        $this$beforeNextElementSetup.vb5_1.cb9('aspect-ratio', null);
        tmp_7 = Unit_instance;
      } else {
        $this$beforeNextElementSetup.vb5_1.cb9('aspect-ratio', '' + constraints_0.rcr_1 + ' / 1');
        tmp_7 = Unit_instance;
      }
      var tmp_8;
      var tmp_9 = constraints_0.scr_1;
      if ((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.width' call
        $this$beforeNextElementSetup.vb5_1.db4_1.hb7_1.width = null;
        tmp_8 = Unit_instance;
      } else {
        var tmp0_3 = $this$beforeNextElementSetup.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.width' call
        var value_3 = _Dimension___get_value__impl__urhqzr(constraints_0.scr_1).toString();
        tmp0_3.hb7_1.width = value_3;
        tmp_8 = Unit_instance;
      }
      var tmp_10;
      var tmp_11 = constraints_0.tcr_1;
      if ((tmp_11 == null ? null : new (Dimension())(tmp_11)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.height' call
        $this$beforeNextElementSetup.vb5_1.db4_1.hb7_1.height = null;
        tmp_10 = Unit_instance;
      } else {
        var tmp0_4 = $this$beforeNextElementSetup.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.height' call
        var value_4 = _Dimension___get_value__impl__urhqzr(constraints_0.tcr_1).toString();
        tmp0_4.hb7_1.height = value_4;
        tmp_10 = Unit_instance;
      }
      return Unit_instance;
    });
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
function sizedBox(_this__u8e3s4, constraints) {
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    var tmp = constraints.pcr_1;
    if ((tmp == null ? null : new (Dimension())(tmp)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.minHeight' call
      _this__u8e3s4.vb5_1.db4_1.hb7_1.minHeight = null;
    } else {
      var tmp0 = _this__u8e3s4.vb5_1.db4_1;
      // Inline function 'com.lightningkite.kiteui.views.minHeight' call
      var value = _Dimension___get_value__impl__urhqzr(constraints.pcr_1).toString();
      tmp0.hb7_1.minHeight = value;
    }
    var tmp_0 = constraints.qcr_1;
    if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.maxHeight' call
      _this__u8e3s4.vb5_1.db4_1.hb7_1.maxHeight = null;
    } else {
      var tmp0_0 = _this__u8e3s4.vb5_1.db4_1;
      // Inline function 'com.lightningkite.kiteui.views.maxHeight' call
      var value_0 = _Dimension___get_value__impl__urhqzr(constraints.qcr_1).toString();
      tmp0_0.hb7_1.maxHeight = value_0;
    }
    var tmp_1 = constraints.ncr_1;
    if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.minWidth' call
      _this__u8e3s4.vb5_1.db4_1.hb7_1.minWidth = null;
    } else {
      var tmp0_1 = _this__u8e3s4.vb5_1.db4_1;
      // Inline function 'com.lightningkite.kiteui.views.minWidth' call
      var value_1 = _Dimension___get_value__impl__urhqzr(constraints.ncr_1).toString();
      tmp0_1.hb7_1.minWidth = value_1;
    }
    var tmp_2 = constraints.ocr_1;
    if ((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.maxWidth' call
      _this__u8e3s4.vb5_1.db4_1.hb7_1.maxWidth = null;
    } else {
      var tmp0_2 = _this__u8e3s4.vb5_1.db4_1;
      // Inline function 'com.lightningkite.kiteui.views.maxWidth' call
      var value_2 = _Dimension___get_value__impl__urhqzr(constraints.ocr_1).toString();
      tmp0_2.hb7_1.maxWidth = value_2;
    }
    if (constraints.rcr_1 == null) {
      _this__u8e3s4.vb5_1.cb9('aspect-ratio', null);
    } else {
      _this__u8e3s4.vb5_1.cb9('aspect-ratio', '' + constraints.rcr_1 + ' / 1');
    }
    var tmp_3 = constraints.scr_1;
    if ((tmp_3 == null ? null : new (Dimension())(tmp_3)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.width' call
      _this__u8e3s4.vb5_1.db4_1.hb7_1.width = null;
    } else {
      var tmp0_3 = _this__u8e3s4.vb5_1.db4_1;
      // Inline function 'com.lightningkite.kiteui.views.width' call
      var value_3 = _Dimension___get_value__impl__urhqzr(constraints.scr_1).toString();
      tmp0_3.hb7_1.width = value_3;
    }
    var tmp_4 = constraints.tcr_1;
    if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.height' call
      _this__u8e3s4.vb5_1.db4_1.hb7_1.height = null;
    } else {
      var tmp0_4 = _this__u8e3s4.vb5_1.db4_1;
      // Inline function 'com.lightningkite.kiteui.views.height' call
      var value_4 = _Dimension___get_value__impl__urhqzr(constraints.tcr_1).toString();
      tmp0_4.hb7_1.height = value_4;
    }
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
var shownWhen$1Class;
function shownWhen$1() {
  if (shownWhen$1Class === VOID) {
    class $ extends RViewWrapper() {
      constructor($v, $default, $this_shownWhen, $condition) {
        super($this_shownWhen.pc());
        $v._v = this;
        this.vb5_1.zb3_1 = 'div';
        this.vb5_1.jb4_1.v('noInteraction');
        this.vb5_1.jb4_1.v('kiteui-stack');
        var tmp0 = this.vb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.hidden' call
        var value = !$default;
        tmp0.kb7_1.hidden = value;
        var currentState = {_v: $default};
        reactive(this, ($this$reactive) => {
          var tmp;
          if (get_areAnimationsEnabled(this) && this.sb6_1) {
            // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
            var c = $condition($this$reactive);
            if (!(c === currentState._v)) {
              // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
              if ($condition($this$reactive)) {
                nativeAnimateShow(this);
              } else {
                nativeAnimateHide(this);
              }
            }
            currentState._v = c;
            tmp = Unit_instance;
          } else {
            // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
            var c_0 = $condition($this$reactive);
            if (!(c_0 === currentState._v)) {
              var tmp0 = this.vb5_1.bb4_1;
              // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
              // Inline function 'com.lightningkite.kiteui.views.hidden' call
              var value = !$condition($this$reactive);
              tmp0.kb7_1.hidden = value;
            }
            currentState._v = c_0;
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      wb9(index, view) {
        protoOf(RViewWrapper()).wb9.call(this, index, view);
        view.kba(true);
        Companion_instance.nbg(this, index, view);
      }
      vb9() {
        var tmp0_safe_receiver = this.tb6_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vb9();
        var tmp;
        var tmp_0 = tmp1_elvis_lhs;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          tmp = get_px(0);
        } else {
          tmp = tmp1_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($);
    shownWhen$1Class = $;
  }
  return shownWhen$1Class;
}
var shownWhen$2Class;
function shownWhen$2() {
  if (shownWhen$2Class === VOID) {
    class $ extends ViewWrapper() {
      constructor($v, $box) {
        if ($box === VOID)
          $box = {};
        $box.qcu_1 = $v;
        super($box);
      }
      rcu() {
        return this.qcu_1._v;
      }
    }
    initMetadataForClass($);
    shownWhen$2Class = $;
  }
  return shownWhen$2Class;
}
//region block: exports
export {
  align as align1ejncrrer3meh,
  changingSizeConstraints as changingSizeConstraints2ompnjjk125zt,
  hintPopover as hintPopover2584paxgnbc51,
  shownWhen as shownWhenxgf1ujy6rmvr,
  sizedBox as sizedBox1c7jm55crxo9r,
  weight as weightt34o7llf2uyq,
};
//endregion

//# sourceMappingURL=modifiers.commonHtml.mjs.map
